/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions} from 'angular';
import TSBenutzer from '../../../models/TSBenutzer';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import {IStateService} from 'angular-ui-router';
import {IBenutzerEditStateParams} from '../../benutzerverwaltung.route';

let template = require('./benutzerListView.html');
let styles = require('./benutzerListView.scss');

export class BenutzerListViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerListViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        benutzerToShow: '<',
    };
}

export class BenutzerListViewController {
    benutzerToShow: Array<TSBenutzer>;

    loadedAnlaufstelleId: string; //remember id of currently loaded anlaufstelle

    static $inject = ['AnlaufstelleRS', '$state'];

    /* @ngInject */
    constructor(private anlaufstelleRS: AnlaufstelleRS, private $state: IStateService) {
    }

    $onInit() {

    }

    public editBenutzer(benutzer: TSBenutzer, event: any) {
        let params: IBenutzerEditStateParams = {benutzerId: benutzer.id, benutzer: benutzer};
        this.$state.go('benutzeredit', params)
    }

    public addBenutzer() {
        let createdBenutzer = new TSBenutzer();
        let params: any = {benutzerId: undefined, benutzer: createdBenutzer};
        this.$state.go('benutzeredit', params);

    }

}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerListView/benutzerListView.ts